module.exports = prestashop;


//////////////////
// WEBPACK FOOTER
// external "prestashop"
// module id = 52
// module chunks = 0